"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const silo_action_1 = __importDefault(require("../silo.action"));
const store_1 = require("store");
const app_action_1 = __importDefault(require("pages/app.action"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const silo_details_modal_1 = __importDefault(require("./silo.details.modal"));
const silo_history_modal_1 = __importDefault(require("./silo.history.modal"));
require("react-toastify/dist/ReactToastify.css");
const react_1 = require("react");
const silo_sub_component_1 = __importDefault(require("./silo.sub-component"));
const silo_mutation_component_1 = __importDefault(require("./silo.mutation.component"));
const app_types_1 = require("pages/app.types");
const react_toastify_1 = require("react-toastify");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const tab_1 = __importDefault(require("components/molecules/tabs/tab"));
const silo_pos_1 = require("pages/silo-pos");
const modal_1 = require("components/molecules/modal");
const authorization_1 = require("utils/authorization");
const Silo = () => {
    var _a;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const { appTheme } = (0, store_1.useAppSelector)((state) => state.app);
    const { isError, isLoading, isSuccess, onReset, isToast, messageToast, dataStates, dataHauler, dataItem, hex_tag, dataStatesHistory, listHauler, onCallWebSocket, errorMessage, dataConfigSilo, isGetDataHauler, mutationMode, } = (0, store_1.useAppSelector)((state) => state.silo);
    const { configurationCheckPointData: dataPos, checkpointChild, deviceData } = (0, store_1.useAppSelector)((state) => state.siloPos);
    const { userData } = (0, store_1.useAppSelector)((state) => state.auth);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Silo');
    const accessOperatorSilo = (0, authorization_1.userOperatorAccess)(userData.operator_access, 'Silo');
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const [tabsMode, setTabsMode] = (0, react_1.useState)('');
    const siloTabs = checkpointChild.map((item, idx) => ({ index: idx, labels: item.checkpoint_name }));
    const onChangeTab = (mode) => {
        setTabsMode(mode);
        const [findCheckpoint] = checkpointChild.filter(item => item.checkpoint_name === mode);
        dispatch(silo_pos_1.siloPosAction.getLandingPageSilo({ checkpoint_id: findCheckpoint.checkpoint_id }));
        dispatch({ type: app_types_1.appTypes.RESET_LOADING });
    };
    const siloLed = dataConfigSilo.find((el) => el.checkpoint_name.toLowerCase() === tabsMode.toLowerCase());
    const url = `ws://${(_a = deviceData.find(i => i.name_device == 'PC')) === null || _a === void 0 ? void 0 : _a.ip_address}:${String(process.env.RFID_PORT)}`;
    const showToastMessage = () => {
        react_toastify_1.toast.error(messageToast, {
            position: react_toastify_1.toast.POSITION.TOP_CENTER
        });
    };
    (0, react_1.useEffect)(() => {
        if (location.protocol == 'http:') {
            const ws = new WebSocket(url);
            try {
                if (onCallWebSocket) {
                    ws.onopen = (i) => console.log('WS open for ', url, i);
                    ws.onmessage = function (event) {
                        return __awaiter(this, void 0, void 0, function* () {
                            const { isError, data, errorMessage, errorType } = JSON.parse(event.data);
                            try {
                                if (!isError) {
                                    if (hex_tag != data.hex_tag) {
                                        console.log('Success', url, data);
                                        dispatch(silo_action_1.default.getDataHauler(data.hex_tag));
                                    }
                                    else {
                                        console.log('Hauler already scanned');
                                    }
                                    // ws.close()
                                }
                                else {
                                    if (errorType != 'TIMEOUT')
                                        dispatch(silo_action_1.default.onClickMutation({
                                            mutationMode: mutationMode,
                                            messageToast: errorMessage,
                                            isToast: true
                                        }));
                                    console.log('Error', errorMessage);
                                }
                            }
                            catch (err) {
                                console.log('Failed', err);
                            }
                        });
                    };
                    ws.onclose = () => console.log('ws closed ', url);
                }
            }
            catch (error) {
                console.error(error);
            }
            return () => {
                ws.close();
            };
        }
        return () => {
            console.log('Please use http');
        };
    }, [onCallWebSocket, dataPos.checkpoint_id]);
    (0, react_1.useEffect)(() => {
        if (location.protocol == 'http:') {
            const ws = new WebSocket(url);
            try {
                ws.onopen = () => console.log('Pinging.. ', url);
                ws.onmessage = function (event) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const { ping } = JSON.parse(event.data);
                        try {
                            if (!ping) {
                                dispatch(silo_action_1.default.setStatus({ status: 'Offline' }));
                            }
                            else {
                                dispatch(silo_action_1.default.setStatus({ status: 'Online' }));
                            }
                        }
                        catch (err) {
                            console.log(err);
                            // dispatch(actions.setStatus({ status: 'Offline' }))
                        }
                    });
                };
            }
            catch (error) {
                console.error(error);
            }
            return () => {
                ws.close();
            };
        }
        return () => {
            console.log('Please use http');
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const intervalId = setInterval(() => {
            if (isSuccess) {
                dispatch(silo_action_1.default.onDataStateChange(dataStates));
                dispatch(silo_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false, isLoadingHistory: true }));
            }
        }, 1000);
        return () => clearInterval(intervalId);
    }, [isSuccess]);
    (0, react_1.useEffect)(() => {
        dispatch(silo_action_1.default.pushLED(dataPos));
    }, [dataPos, isSuccess]);
    (0, react_1.useEffect)(() => {
        if (isToast) {
            showToastMessage();
            dispatch(silo_action_1.default.onClickMutation({
                mutationMode: mutationMode,
                messageToast: '',
                isToast: false
            }));
        }
    }, [isToast]);
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading)
                dispatch(silo_action_1.default.getSiloConfig(dataStates));
            dispatch(silo_action_1.default.setDataSiloTabs({ dataSiloTabs: siloLed, dataHauler }));
            if (accessOperatorSilo.length > 0 && checkpointChild.length === 0) {
                navigate('/choose-pos-silo');
            }
            if (accessOperatorSilo.length === 1 && checkpointChild.length === 0) {
                const [{ checkpoint_child }] = accessOperatorSilo;
                if (checkpoint_child) {
                    const [{ checkpoint_id }] = checkpoint_child;
                    dispatch(app_action_1.default.appActionSelectMenu({ menu: 'Silo', subMenu: null }));
                    dispatch(silo_pos_1.siloPosAction.getLandingPageSilo({ checkpoint_id: checkpoint_id }));
                    dispatch(silo_pos_1.siloPosAction.setSelectedChild({ checkpointChild: checkpoint_child }));
                }
            }
            if (checkpointChild.length > 0) {
                const [{ checkpoint_name }] = checkpointChild;
                setTabsMode(checkpoint_name);
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [, isAuthorized, fullScreen, tabsMode, checkpointChild]);
    (0, react_1.useEffect)(() => {
        if (isGetDataHauler) {
            if ((dataHauler === null || dataHauler === void 0 ? void 0 : dataHauler.checkpoint_id) == '')
                dispatch(silo_action_1.default.setDataSiloTabs({ dataSiloTabs: siloLed, dataHauler }));
        }
    }, [isGetDataHauler]);
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'passive') {
            if (listHauler.length == 0)
                dispatch(silo_action_1.default.getDataHaulerList());
        }
    }, [mutationMode, dataItem]);
    (0, react_1.useEffect)(() => {
        if (dataItem.contractor_id !== '') {
            dispatch(silo_action_1.default.getDataDropdown({ contractor_id: dataItem.contractor_id }));
        }
    }, [dataItem.contractor_id]);
    (0, react_1.useEffect)(() => {
        if (mutationMode === false && dataPos.checkpoint_id) {
            const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { filter: {
                    logic: 'and',
                    filters: [{
                            operator: 'uuid',
                            field: 'checkpoint_id',
                            value: dataPos.checkpoint_id
                        }]
                } });
            dispatch(silo_action_1.default.getDataHistory(newDataStatesHistory));
        }
    }, [mutationMode, dataPos, isSuccess]);
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    window.onload = widthCheker;
    window.onresize = widthCheker;
    const getHistory = () => {
        if (dataPos.checkpoint_id !== '') {
            const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { filter: {
                    logic: 'and',
                    filters: [{
                            operator: 'uuid',
                            field: 'checkpoint_id',
                            value: dataPos.checkpoint_id
                        }]
                } });
            dispatch(silo_action_1.default.getDataHistory(newDataStatesHistory));
        }
    };
    const [hiddenMessageValue, onChangeHiddenMessage] = (0, react_1.useState)(true);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: {
            width: fullScreen ? 'auto' : 'max-content',
            height: 'inherit',
        } }, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { isHiddenMessage: true, hiddenMessageValue: hiddenMessageValue, onChangeHiddenMessage: onChangeHiddenMessage, title: 'Silo', theme: appTheme, isLoading: isLoading, isHistory: isAuthorized.view, isReset: isAuthorized.view, onReset: () => {
                    dispatch({ type: app_types_1.appTypes.RESET_LOADING });
                    dispatch(silo_action_1.default.onReset({ onReset: !onReset }));
                    getHistory();
                }, onHistory: () => {
                    getHistory();
                    dispatch(silo_action_1.default.onClickMutation({ mutationMode: 'history', dataHauler, dataItem }));
                } }), (0, jsx_runtime_1.jsx)(tab_1.default, { tabs: siloTabs, onChangeTab: onChangeTab }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data saved Successfully', onClose: () => {
                    dispatch(silo_action_1.default.onDataStateChange(dataStates));
                    dispatch(silo_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false, isLoadingHistory: true }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { zIndex: 10 }, errorMessage: errorMessage, onClose: () => {
                    dispatch(silo_action_1.default.toggleError({ isError: false, errorCode: 0, errorMessage: '' }));
                    dispatch(silo_action_1.default.onClickMutation({ mutationMode: false, dataItem, dataHauler }));
                } }), !hiddenMessageValue && ((0, jsx_runtime_1.jsx)(react_toastify_1.ToastContainer, { style: { zIndex: 8 } })), (0, jsx_runtime_1.jsx)(silo_history_modal_1.default, {}), (0, jsx_runtime_1.jsx)(silo_details_modal_1.default, { isAuthorized: isAuthorized }), (0, jsx_runtime_1.jsx)(silo_mutation_component_1.default, { isAuthorized: isAuthorized }), (0, jsx_runtime_1.jsx)(silo_sub_component_1.default, { isAuthorized: isAuthorized })] })));
};
exports.default = Silo;
